/** Setting rows: a label on the left, the value on the right between ◄ ► while selected. */

import { textWidth } from '../../render/font';
import { GREEN, LIGHT_GREEN, YELLOW } from '../../render/palette';
import type { Screen } from '../../render/screen';
import { drawSpinner } from './spinner';
import { ACCENT, blink, FAINT, INK, MUTED, SELECTED } from './theme';

export type RowValue =
  | { readonly kind: 'choice'; readonly text: string }
  | { readonly kind: 'level'; readonly value: number; readonly max: number }
  /** Opens another screen. */
  | { readonly kind: 'link' };

export interface RowColumns {
  readonly label: number;
  readonly value: number;
}

const CELL_W = 6;

/** Colour of volume cell `i` of `max` (quiet green to loud yellow). Pure. */
export function levelColour(i: number, max: number): number {
  const f = max <= 1 ? 1 : i / (max - 1);
  return f < 0.45 ? GREEN : f < 0.8 ? LIGHT_GREEN : YELLOW;
}

export function drawOptionRow(
  screen: Screen, y: number, label: string, value: RowValue, selected: boolean, ms: number, cols: RowColumns,
): void {
  if (selected) drawSpinner(screen, cols.label - 13, y, ms);
  screen.text(label, cols.label, y, selected ? SELECTED : INK);
  const vx = cols.value;
  if (value.kind === 'choice') {
    screen.text(value.text, vx, y, selected ? SELECTED : ACCENT);
    if (selected) {
      screen.text('◄', vx - 10, y, blink(ms, 900) ? SELECTED : MUTED);
      screen.text('►', vx + textWidth(value.text) + 2, y, blink(ms, 900) ? SELECTED : MUTED);
    }
  } else if (value.kind === 'level') {
    for (let i = 0; i < value.max; i++) {
      const x = vx + i * (CELL_W + 1);
      if (i < value.value) screen.fill(x, y + 1, CELL_W, 6, levelColour(i, value.max));
      else screen.box(x, y + 1, CELL_W, 6, FAINT);
    }
    const nx = vx + value.max * (CELL_W + 1) + 4;
    screen.text(String(value.value), nx, y, selected ? SELECTED : ACCENT);
    if (selected) {
      screen.text('◄', vx - 10, y, blink(ms, 900) ? SELECTED : MUTED);
      screen.text('►', nx + textWidth(String(value.value)) + 2, y, blink(ms, 900) ? SELECTED : MUTED);
    }
  } else {
    const dx = selected ? Math.round(Math.max(0, Math.sin(ms / 140)) * 2) : 0;
    screen.text('►', vx + dx, y, selected ? SELECTED : MUTED);
  }
}
